import { useState, useEffect } from 'react';
import axios from 'axios';
import ArticleCard from '../../Components/buyer/ArticleCard';
import banner1 from '../../images/pngs/banner1.png';
import banner2 from '../../images/pngs/banner2.jpg';
import banner3 from '../../images/pngs/banner3.jpg';
import Loader from '../../Components/utils/Loader';
import SEO from '../../Components/utils/SEO';

const BlogPage = () => {
    const [activeTab, setActiveTab] = useState('all');
    const [blogs, setBlogs] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        fetchBlogs();
    }, []);

    const fetchBlogs = async () => {
        try {
            setIsLoading(true);
            const { data } = await axios.get(`${process.env.REACT_APP_Backend_Host_Name}/api/v1/blogs`);
            if (data.success) {
                setBlogs(data.blogs);
            }
        } finally {
            setIsLoading(false);
        }
    };

    const categoryBanners = {
        all: { title: "All Articles", image: banner1, description: "Discover all our blog articles and recipes" },
        recipes: { title: "Recipes", image: banner1, description: "Discover delicious recipes for every occasion" },
        healthy: { title: "Healthy Living", image: banner2, description: "Nutritious and wholesome meal ideas" },
        yummy: { title: "Yummy Treats", image: banner3, description: "Indulgent recipes for sweet cravings" }
    };

    let filteredArticles = blogs.filter(blog => {
        if (activeTab === 'all') return true;
        if (activeTab === 'recipes') return blog.category === 'Recipes';
        if (activeTab === 'healthy') return blog.category === 'Healthy';
        if (activeTab === 'yummy') return blog.category === 'Yummy';
        return true;
    });

    const seoTitle = activeTab === 'all'
        ? 'Chocowi blog'
        : `${categoryBanners[activeTab].title} articles`;
    const seoDescription = categoryBanners[activeTab]?.description
        || 'Read recipes, healthy living tips, and sweet inspiration from Chocowi.';

    if (isLoading) {
        return (
            <>
                <SEO title={seoTitle} description={seoDescription} canonicalPath="/blogs" />
                <Loader type="simpleMax" />
            </>
        );
    }

    const banner = categoryBanners[activeTab];

    return (
        <div className="blogPage">
            <SEO title={seoTitle} description={seoDescription} canonicalPath="/blogs" />
            <div className="blogPageHero">
                <div className="blogPageHeroImage">
                    <img src={banner.image} alt={banner.title} />
                    <div className="blogPageHeroOverlay" />
                </div>
                <div className="blogPageHeroContent">
                    <h1>{banner.title}</h1>
                    <p>{banner.description}</p>
                </div>
            </div>

            <section className="mainSection">
                <div className="blogPageTabs">
                    {['all', 'recipes', 'healthy', 'yummy'].map(tab => (
                        <button
                            key={tab}
                            type="button"
                            className={`blogPageTab ${activeTab === tab ? 'active' : ''}`}
                            onClick={() => setActiveTab(tab)}
                        >
                            {categoryBanners[tab].title}
                        </button>
                    ))}
                </div>

                <div className="blogPageGrid">
                    {filteredArticles.length === 0 ? (
                        <p className="blogPageEmpty">No articles in this category yet.</p>
                    ) : (
                        filteredArticles.map((blog) => (
                            <ArticleCard
                                key={blog._id}
                                title={blog.title}
                                date={blog.date}
                                image={blog.image}
                                category={blog.category}
                                slug={blog.slug}
                            />
                        ))
                    )}
                </div>
            </section>
        </div>
    );
};

export default BlogPage;